// extracted by mini-css-extract-plugin
module.exports = {"row":"antd-pro-pages-account-settings-components-geographic-view-row","item":"antd-pro-pages-account-settings-components-geographic-view-item"};